import React from "react";
import Header from '../Header/Header';
import ChatsList from './ChatsList';

export default function StaffChatsPage() {

    return (
        <div className="min-h-screen bg-[#edeef2]">
            <Header />
            <main
                className={`
                    pt-[70px]
                    transition-all duration-300
                    md:ml-72
                `}
            >
                <div className="p-4 sm:p-6">
                    <ChatsList />
                </div>
            </main>
        </div>
    );
}